/**
 * Register Page
 *
 * Public page for new user registration
 */

import { RegisterForm } from '../../components/auth/RegisterForm';

export function Register() {
  return <RegisterForm />;
}
